import React, { FunctionComponent } from "react";
const styles = {
  counter: {
    minWidth: "28px",
    position: "relative" as const,
    borderRadius: "100px",
    backgroundColor: "#fcd9f5",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 6px",
    boxSizing: "border-box" as const,
    textAlign: "left" as const,
    fontSize: "12px",
    color: "#ef10be",
    fontFamily:
      'Poppins, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  value: {
    position: "relative" as const,
    letterSpacing: "-0.02em",
    lineHeight: "16px",
    fontWeight: 600,
  },
};

interface CounterProps {
  value: number | string;
}

const Counter: FunctionComponent<CounterProps> = ({ value }) => {
  return (
    <div style={styles.counter}>
      <b style={styles.value}>{value}</b>
    </div>
  );
};

export default Counter;


